export enum PageViews {
    QUOTE_TAB = "QUOTE_TAB_CLICKED",
    BIKE_TAB = "BIKE_TAB_CLICKED",
    MESSAGES_TAB = "MESSAGES_TAB_CLICKED"
}
